import React, { useState, useRef ,useEffect } from 'react';
import Slider from 'react-slick';
import { Link } from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FlightSearchForm from '../Components/FlightSearchForm';
import destinations from '../data/destinations.json';
import HotelSearchForm from '../Components/HotelsSearchForm';
import FlightHotelForm from '../Components/FlightHotelForm';
import HajjUmrahForm from '../Components/HajjUmrahForm';
import TopAirlines from '../Components/TopAirlines';

function Home(){

     // Sort the destinations array by the "to" property in ascending order
    const sortedDestinations = [...destinations].sort((a, b) => 
        a.to.localeCompare(b.to)
    );

    const testimonialSlider = {
        infinite: true,
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: true,
         dots: false,
         autoplay: true,
         speed: 2000,
         loop:false,
         responsive: [{
             breakpoint: 991,
             settings: {
                 slidesToShow: 1,
                 arrows: false,
             }
         }]
    }
    const sliderHeader = {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        speed: 5000,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    return (
     <>
    <section className='searchParent'>
        <div className="container"> 
            <div className="row"> 
                <h2 className='topHeading'>Find Out Best Deals For Your Next Trip</h2>
               <ul className="nav nav-tabs nav-pills nav-fill bg-transparent mb-0" id="postsTab1" role="tablist">
                    
                    <li className="nav-item" role="presentation">
                        <button aria-selected="true" className="nav-link active white" data-bs-target="#flight" data-bs-toggle="tab" id="flight-tab" role="tab" type="button">Flight</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button aria-selected="true" className="nav-link white" data-bs-target="#hotel" data-bs-toggle="tab" id="hotel-tab" role="tab" type="button">Hotel</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button  aria-selected="false" className="nav-link white" data-bs-target="#holiday" data-bs-toggle="tab" id="tour-tab" role="tab" type="button">Flight + Hotel</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button  aria-selected="false" className="nav-link white" data-bs-target="#hajjumrah" data-bs-toggle="tab" id="hajjumrah-tab" role="tab" type="button">Hajj / Umrah</button>
                    </li>
                </ul>  
                <div className="tab-content" id="postsTabContent1">
                    <div aria-labelledby="flight-tab" className="tab-pane fade active show" id="flight" role="tabpanel">
                        {/*Flight Search Form*/}
                        <FlightSearchForm />  
                    </div>
                    <div aria-labelledby="hotel-tab" className="tab-pane fade " id="hotel" role="tabpanel">
                        <HotelSearchForm />
                    </div>
                    <div aria-labelledby="holiday-tab" className="tab-pane fade" id="holiday" role="tabpanel">
                        <FlightHotelForm />
                    </div>
                    <div aria-labelledby="hajjumrah-tab" className="tab-pane fade" id="hajjumrah" role="tabpanel">
                        <HajjUmrahForm />
                    </div>
                </div>               
            
            </div>
        </div>
    </section>
    

    <section className="about-us pb-0 pt-6" >
        <div className="container">

            <div className="section-title mb-6 w-80 mx-auto text-center">
                <h2 className="mb-1"><span style={{color: "#FF4778"}}>Why</span> <span className="theme">Choose The Holiday Experts?</span></h2>
            </div>

            
            <div className="why-us">
                <div className="why-us-box">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                            <div className="why-us-item text-center p-4 py-3 border rounded bg-white">
                                <div className="why-us-content">
                                    
                                    <h4>Personalized Travel Solutions</h4>
                                    <p className="mb-0">We understand that every traveler is different. That's why we offer tailored travel packages that suit your needs, preferences, and budget.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                            <div className="why-us-item text-center p-4 py-3 border rounded bg-white">
                                <div className="why-us-content">
                                   
                                    <h4>Expert Advice</h4>
                                    <p className="mb-0">With years of experience, our team of travel experts provides you with the best advice, helping you choose the perfect destination, flights, and accommodation.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                            <div className="why-us-item text-center p-4 py-3 border rounded bg-white">
                                <div className="why-us-content">
                                    
                                    <h4>Exclusive Deals & Offers</h4>
                                    <p className="mb-0">Take advantage of our exclusive travel deals and promotions to get the best value for your money.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                            <div className="why-us-item text-center p-4 py-3 border rounded bg-white">
                                <div className="why-us-content">
                                    
                                    <h4>Book Now, Pay Later </h4>
                                    <p className="mb-0">Book now with a small deposit, pay the rest later so you don’t miss out the best option.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="white-overlay"></div>
    </section>



    {/* Our Services Start */}
    <section className="trending pb-0">
        <div className="container">
            <div className="row align-items-center justify-content-between mb-6 ">
                <div className="col-lg-12">
                    <div className="section-title mb-2 w-50 mx-auto text-center">
                        
                        <h2><span style={{color: "#FF4778"}}>Our</span> <span className="theme">Services</span></h2>
                        
                    </div>
                </div>
            </div>
            <div className="trend-box">
                <div className="row item-slider">
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <Link to='/top-destinations' >
                        <div className="trend-item rounded box-shadow">
                            <div className="trend-image position-relative">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/Flights.jpg`} className="" alt="" />
                                <div className="color-overlay"></div>
                            </div>
                            <div className="trend-content p-4 pt-5 position-relative">
                               <div className="trend-meta bg-theme white px-3 py-2 rounded">
                                    <div className="entry-author">
                                        <span className="fw-bold">Starting From £19</span>
                                    </div>
                                </div>
                                <h5 className="mb-1">Flights</h5>
                                <p className="pb-2 mb-2">Discover affordable flights worldwide, compare options, and book easily for business or leisure travel. Your journey starts here!"</p>
                                
                            </div>
                        </div>
                        </Link>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <Link to='/hotels' >
                        <div className="trend-item box-shadow rounded">
                            <div className="trend-image position-relative">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/Hotels.jpg`} className="" alt="" />
                                <div className="color-overlay"></div>
                            </div>
                            <div className="trend-content p-4 pt-5 position-relative">
                                <div className="trend-meta bg-theme white px-3 py-2 rounded">
                                    <div className="entry-author">
                                        <span className="fw-bold">Starting From £14</span>
                                    </div>
                                </div>
                                <h5 className="mb-1">Hotels</h5>
                                <p className="pb-2 mb-2">Find the best hotel deals worldwide. Compare prices, amenities, and book your perfect stay for business or leisure.</p>
                            </div>
                        </div>
                        </Link>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <Link to='/holiday-packages'>
                        <div className="trend-item box-shadow rounded">
                            <div className="trend-image position-relative">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/Holidays.jpg`} className="" alt="" />
                                <div className="color-overlay"></div>
                            </div>
                            <div className="trend-content p-4 pt-5 position-relative">
                                <div className="trend-meta bg-theme white px-3 py-2 rounded">
                                    <div className="entry-author">
                                        <span className="fw-bold">Starting From £297</span>
                                    </div>
                                </div>
                                <h5 className="mb-1">Holidays Packages</h5>
                               
                                <p className="pb-2 mb-2">Explore unbeatable holiday packages worldwide. Discover tailored trips, compare options, and book your dream vacation with ease.</p>

                            </div>
                        </div>
                        </Link>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                        <Link to='/hajj-umrah' >
                        <div className="trend-item box-shadow rounded">
                            <div className="trend-image position-relative">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/Umrah.jpg`} className="" alt="" />
                                <div className="color-overlay"></div>
                            </div>
                            <div className="trend-content p-4 pt-5 position-relative">
                                <div className="trend-meta bg-theme white px-3 py-2 rounded">
                                    <div className="entry-author">
                                        <span className="fw-bold">Starting From £548</span>
                                    </div>
                                </div>
                                <h5 className="mb-1">Umrah Packages</h5>
                               
                                <p className=" pb-2 mb-2">Browse affordable Umrah packages. Book your spiritual journey with ease, offering flights, accommodation, and guided tours for a blessed experience.</p>

                            </div>
                        </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* Our Services Ends */}

    {/* Explore Destinations Start */}
    <section className="pb-15">
        <div className="container">
            <div className="row align-items-center justify-content-between mb-6 ">
                <div className="col-lg-12">
                    <div className="section-title w-80 mx-auto text-center">
                        
                        <h2 className="mb-1"><span style={{color: "#FF4778"}}>Explore</span> <span className="theme">Popular Destinations</span></h2>
                        
                    </div>
                </div>
            </div>
            <div className="row mb-2">

                {sortedDestinations.map((destination, index) => ( 
                <div className='col-lg-4 mb-1' key={index}>
                    
                    <Link to={`/flights/fly-${encodeURIComponent(destination.from)}-to-${destination.to.replace(/ /g, '-')}`}  >
                        <div className='destinationList' >
                                <span className='cheapFlightText'>
                                    Cheap Flights
                                </span>
                                <span className='destinationText' >
                                    {destination.from} to {destination.to}
                                </span>
                        </div>
                    </Link>
                </div>
                ))}
            </div>
            
        </div>
        <div className="white-overlay"></div>
    </section>        
    {/* Explore Destinations End */}    

    {/*} testomonial start */}
    <section className="testimonial pt-9" >
        <div className="container">
            <div className="section-title mb-6 text-center w-75 mx-auto">
                
                <h2 className="mb-1">Good Reviews By <span className="theme">Clients</span></h2>
                
            </div>
            <div className="row align-items-center">
                
                <div className="col-lg-12 ps-4">
                    <div className="row review-slider">
                        <Slider {...testimonialSlider}>
                        <div className="col-sm-4 item">
                            <div className="testimonial-item1 rounded">
                                <div className="author-info d-flex align-items-center mb-4">
                                     <img src={`${process.env.PUBLIC_URL}/assets/images/testimonial/img1.jpg`} className="" alt="" />
                                    <div className="author-title ms-3">
                                        <h5 className="m-0 theme">Jared Erondu</h5>
                                        <span>Supervisor</span>
                                    </div>
                                </div>
                                <div className="details">
                                    <p className="m-0"><i className="fa fa-quote-left me-2 fs-1"></i>Lorem Ipsum is simply dummy
                                        text of the printing andypesetting industry. Lorem ipsum a simple Lorem Ipsum
                                        has been the industry's standard dummy hic et quidem. Dignissimos maxime velit
                                        unde inventore quasi vero dolorem.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 item">
                            <div className="testimonial-item1 rounded">
                                <div className="author-info d-flex align-items-center mb-4">
                                    
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/testimonial/img1.jpg`} className="" alt="" />
                                    <div className="author-title ms-3">
                                        <h5 className="m-0 theme">Jared Erondu</h5>
                                        <span>Supervisor</span>
                                    </div>
                                </div>
                                <div className="details">
                                    <p className="m-0"><i className="fa fa-quote-left me-2 fs-1"></i>Lorem Ipsum is simply dummy
                                        text of the printing andypesetting industry. Lorem ipsum a simple Lorem Ipsum
                                        has been the industry's standard dummy hic et quidem. Dignissimos maxime velit
                                        unde inventore quasi vero dolorem.</p>
                                </div>
                            </div>
                        </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* testimonial ends */}

    {/* Top Airlines Start */}
    <TopAirlines />
    {/* Top Airlines End */} 

     </>
    )
}
export default Home;    